// extracted by mini-css-extract-plugin
module.exports = {"slide":"_4e5f713ae4--slide--kXxlM"};